import { usePresence } from "../../lib/use-presence";

/**
 * The composer's one dependency on passkey presence (architecture §9): a send from the web
 * composer runs at once when the person proved presence (the api client then sends
 * `x-kwp-presence`), otherwise it becomes an approval. Before sending, the composer asks for the
 * passkey when there is no valid token. "send" goes ahead (with presence, or, without a passkey,
 * as an approval); "cancelled" means the person dismissed the prompt and nothing is sent.
 */
export function useSendPresence(): () => Promise<"send" | "cancelled"> {
  const { ensurePresence } = usePresence();
  return async () => ((await ensurePresence()) === "cancelled" ? "cancelled" : "send");
}
